import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectStatus } from '../../customComponents/SelectStatus';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';


export const initObject = {
  id: undefined,
  title: "",
  code: "",
  buildingId: 0,
  buildingTitle: "",
  categoryId: null,
  categoryTitle: "",
  floorIndex: 0,
  isDeleted: false
};

export const floorInitObject = {
  id: undefined,
  title: "",
  code: "",
  buildingId: 0,
  buildingTitle: "",
  categoryId: 0,
  categoryTitle: "",
  roomsCount: "",
  floorIndex: 0,
  isDeleted: false
};

export const columns = [
  {
    dataField: "title",
    text: "عنوان طبقه",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "code",
    text: "کد",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "floorIndex",
    text: "طبقه چندم",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "buildingTitle",
    text: "بلوک",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "roomsCount",
    text: "تعداد اتاق",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "isDeleted",
    // text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    text: "وضعیت",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },
  // {
  //   dataField: "action",
  //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
  //   // text: "Actions",
  //   formatter: columnFormatters.ActionsColumnFormatter,
  //   formatExtraData: {
  //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
  //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "100px",
  //   },
  // },
];

export const floorColumns = [
  {
    dataField: "title",
    text: "عنوان طبقه",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "code",
    text: "کد",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "categoryTitle",
    text: "کاربری",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "floorIndex",
    text: "طبقه چندم",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "buildingTitle",
    text: "بلوک",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "isDeleted",
    // text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    text: "وضعیت",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },
  // {
  //   dataField: "action",
  //   text: columnFormatters.translateByMessageId("MODULES.GENERAL.ACTION"),
  //   // text: "Actions",
  //   formatter: columnFormatters.ActionsColumnFormatter,
  //   formatExtraData: {
  //     // openEditObjectPage: objectsUIProps.openEditObjectPage,
  //     // openDeleteObjectDialog: objectsUIProps.openDeleteObjectDialog,
  //   },
  //   classes: "text-right pr-0",
  //   headerClasses: "text-right pr-3",
  //   style: {
  //     minWidth: "100px",
  //   },
  // },
];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان طبقه",
        label: "عنوان طبقه",
        rowIdx: 2,
        class: "col-lg-4"
      },
      {
        name: "code",
        type: "text",
        component: Input,
        placeholder: "کد",
        label: "کد",
        rowIdx: 3,
        class: "col-lg-4"
      },
      {
        name: "floorIndex",
        label: "طبقه چندم",
        type: "localSelect",
        list: [
          {
            value: "-3",
            lable: "-3",
          },
          {
            value: "-2",
            lable: "-2",
          },
          {
            value: "-1",
            lable: "-1",
          },
          {
            value: "0",
            lable: "همکف",
          },
          {
            value: "1",
            lable: "1",
          },
          {
            value: "2",
            lable: "2",
          },
          {
            value: "3",
            lable: "3",
          },
          {
            value: "4",
            lable: "4",
          },
          {
            value: "5",
            lable: "5",
          },
          {
            value: "6",
            lable: "6",
          },
          {
            value: "7",
            lable: "7",
          },
          {
            value: "8",
            lable: "8",
          },
          {
            value: "9",
            lable: "9",
          },
          {
            value: "10",
            lable: "10",
          },
        ],
        rowIdx: 4,
        class: "col-lg-4",
      },
      // {
      //   name: "buildingId",
      //   type: "text",
      //   component: (props) =>
      //     <SelectObjectsField api="api/building"
      //       reduxState="buildings"
      //       sname="buildingId"
      //       label="بلوک" {...props} />,
      //   placeholder: "بلوک",
      //   label: "بلوک",
      //   rowIdx: 3,
      //   class: "col-lg-4"
      // },

    ]
  },
  {
    row: 2,
    list: [
      // {
      //   name: "categoryId",
      //   type: "text",
      //   component: (props) => <SelectObjectsField api="api/category"
      //     reduxState="buildingCategories"
      //     sname="categoryId"
      //     label="کاربری" {...props} />,
      //   placeholder: "کاربری",
      //   label: "کاربری",
      //   rowIdx: 4,
      //   class: "col-lg-4"
      // },
      {
        name: "categoryId",
        type: "text",
        component: (props) => <SelectObjectsField api="api/category"
          reduxState="roomCategories"
          sname="categoryId"
          label="کاربری" {...props} />,
        placeholder: "کاربری",
        label: "کاربری",
        rowIdx: 3,
        class: "col-lg-4"
      },
    ]
  },

];

export const floorFormFields = [
  {
    row: 1,
    list: [
      {
        name: "title",
        type: "text",
        component: Input,
        placeholder: "عنوان طبقه",
        label: "عنوان طبقه",
        rowIdx: 2,
        class: "col-lg-4"
      },
      {
        name: "code",
        type: "text",
        component: Input,
        placeholder: "کد",
        label: "کد",
        rowIdx: 3,
        class: "col-lg-4"
      },
      // {
      //   name: "buildingId",
      //   type: "text",
      //   component: (props) =>
      //     <SelectObjectsField api="api/building"
      //       reduxState="buildings"
      //       sname="buildingId"
      //       label="بلوک" {...props} />,
      //   placeholder: "بلوک",
      //   label: "بلوک",
      //   rowIdx: 3,
      //   class: "col-lg-4"
      // },

    ]
  },
  // {
  //   row: 2,
  //   list: [
  //     {
  //       name: "categoryId",
  //       type: "text",
  //       component: (props) => <SelectObjectsField api="api/category"
  //         reduxState="buildingCategories"
  //         sname="categoryId"
  //         label="کاربری" {...props} />,
  //       placeholder: "کاربری",
  //       label: "کاربری",
  //       rowIdx: 4,
  //       class: "col-lg-4"
  //     },
  //   ]
  // },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];

export const floorOtherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];

export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
    buildingId: 0
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};


export const floorFilterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    searchText: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const filterFields = [
  // {
  //   name: "building",
  //   lable: "بلوک",
  //   type: "component",
  //   list: [],
  //   component: (props) =>
  //     <SelectObjectsField api="api/building"
  //       reduxState="buildings"
  //       sname="buildingId"
  //       {...props} />
  // },
  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  // {
  //   name: "categoryId",
  //   lable: "کاربری",
  //   type: "component",
  //   list: [],
  //   component: (props) =>
  //     <SelectObjectsField api="api/category"
  //       reduxState="buildingCategories"
  //       sname="categoryId"
  //       {...props} />
  // },

  // {
  //   name: "searchText",
  //   lable: "MODULES.GENERAL.SEARCH",
  //   type: "text",
  //   list: [],
  // },

];

export const floorFilterFields = [
  // {
  //   name: "building",
  //   lable: "بلوک",
  //   type: "component",
  //   list: [],
  //   component: (props) =>
  //     <SelectObjectsField api="api/building"
  //       reduxState="buildings"
  //       sname="buildingId"
  //       {...props} />
  // },
  // {
  //   name: "isDeleted",
  //   lable: "MODULES.GENERAL.STATUS",
  //   type: "select",
  //   list: [
  //     {
  //       value: "",
  //       lable: "MODULES.GENERAL.STATUSALL",
  //     },
  //     {
  //       value: "0",
  //       lable: "MODULES.GENERAL.STATUSENABLE",
  //     },
  //     {
  //       value: "1",
  //       lable: "MODULES.GENERAL.STATUSDELETED",
  //     },

  //   ],
  //   component: SelectStatus
  // },
  // {
  //   name: "categoryId",
  //   lable: "کاربری",
  //   type: "component",
  //   list: [],
  //   component: (props) =>
  //     <SelectObjectsField api="api/category"
  //       reduxState="buildingCategories"
  //       sname="categoryId"
  //       {...props} />
  // },

  // {
  //   name: "searchText",
  //   lable: "MODULES.GENERAL.SEARCH",
  //   type: "text",
  //   list: [],
  // },

];

export const prepareFilter = (queryParams, values) => {
  const { isDeleted, buildingId, } = values;
  // const { isDeleted, searchText, buildingId, categoryId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  if (isDeleted !== undefined)
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // // Filter by buildingId
  filter.buildingId = buildingId !== "" ? +buildingId : 0;
  // filter.categoryId = categoryId !== "" ? +categoryId : 0;

  // // Filter by all fields
  // filter.title = searchText;
  // if (searchText) {
  //   filter.title = searchText;
  // }
  newQueryParams.filter = filter;
  let whereClause = ""
  const whereClauseParameters = [];

  var idx = 0;
  if (filter.buildingId > 0 && idx === 0) {
    whereClause = `buildingId=@${idx}`
    whereClauseParameters.push(filter.buildingId)
    idx++;
  }
  else if (filter.buildingId > 0 && idx > 0) {
    whereClause = whereClause + ` and buildingId=@${idx}`
    whereClauseParameters.push(filter.buildingId)
    idx++;
  }

  if (filter.isDeleted !== undefined && idx === 0) {
    whereClause = "isDeleted=@0";
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }
  else if (filter.isDeleted !== undefined && idx > 0) {
    whereClause = whereClause + ` and isDeleted=@${idx}`
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }
  // let whereClause = "title.contains(@0)"
  // const whereClauseParameters = [];
  // whereClauseParameters.push(searchText)

  // if (filter.buildingId > 0) {
  //   whereClause = whereClause + " and buildingId=@1"
  //   whereClauseParameters.push(filter.buildingId)
  // }
  // else {
  //   whereClause = whereClause + " and buildingId!=@1"
  //   whereClauseParameters.push(filter.buildingId)
  // }

  // if (filter.categoryId > 0) {
  //   whereClause = whereClause + " and categoryId=@2"
  //   whereClauseParameters.push(filter.categoryId)
  // }
  // else {
  //   whereClause = whereClause + " and categoryId!=@2"
  //   whereClauseParameters.push(filter.categoryId)
  // }

  // if (filter.isDeleted !== undefined) {
  //   whereClause = whereClause + " and isDeleted=@3"
  //   whereClauseParameters.push(filter.isDeleted === 0 ? false : true)
  // }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};

export const floorPrepareFilter = (queryParams, values) => {
  const { isDeleted, searchText, buildingId, categoryId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // Filter by buildingId
  filter.buildingId = buildingId !== "" ? +buildingId : 0;
  filter.categoryId = categoryId !== "" ? +categoryId : 0;

  // Filter by all fields
  filter.title = searchText;
  if (searchText) {
    filter.title = searchText;
  }
  newQueryParams.filter = filter;

  let whereClause = "title.contains(@0)"
  const whereClauseParameters = [];
  whereClauseParameters.push(searchText)

  if (filter.buildingId > 0) {
    whereClause = whereClause + " and buildingId=@1"
    whereClauseParameters.push(filter.buildingId)
  }
  else {
    whereClause = whereClause + " and buildingId!=@1"
    whereClauseParameters.push(filter.buildingId)
  }

  if (filter.categoryId > 0) {
    whereClause = whereClause + " and categoryId=@2"
    whereClauseParameters.push(filter.categoryId)
  }
  else {
    whereClause = whereClause + " and categoryId!=@2"
    whereClauseParameters.push(filter.categoryId)
  }

  if (filter.isDeleted !== undefined) {
    whereClause = whereClause + " and isDeleted=@3"
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true)
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};
// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  buildingId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  // categoryId: Yup.number()
  //   .positive("پر کردن فیلد الزامی است"),
  categoryId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
});

export const floorObjectEditSchema = Yup.object().shape({
  title: Yup.string()
    .required("پر کردن فیلد الزامی است"),
  buildingId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  // categoryId: Yup.number()
  //   .required("پر کردن فیلد الزامی است"),
  categoryId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
});

